<template>
    <div>
        <header class="panel__header">
            <h2 class="panel__title">Upgrade your account</h2>
        </header>
        <form @submit.prevent="submit()">
            <div class="payment-options">
                <div @click.prevent="changeInterval('yearly')" class="payment-options__item recommended" :class="{'payment-options__item--selected' : form.interval === 'yearly'}">
                    <div class="recommended__item">Recommended - Save 20%</div>
                    <h2>{{ currentTenant.billable_users_count }} Users <span>Yearly</span></h2>
                    <p class="payment-options__price">&dollar;{{ yearlyPrice }} per user a month</p>
                    <p class="payment-options__total">One yearly payment of &dollar;{{ totalYearlyPrice }}</p>
                </div>
                <div @click.prevent="changeInterval('monthly')" class="payment-options__item" :class="{'payment-options__item--selected' : form.interval === 'monthly'}">
                    <h2>{{ currentTenant.billable_users_count }} Users <span>Monthly</span></h2>
                    <p class="payment-options__price">&dollar;{{ monthlyPrice }} per user a month</p>
                    <p class="payment-options__total">One monthly payment of &dollar;{{ totalMonthlyPrice }}</p>
                </div>
            </div>

            <payment-method ref="paymentMethod"></payment-method>

            <coupon v-model="form.coupon"></coupon>

            <p v-if="form.errors.has('subscription')" class="form__help form__help--error">{{ form.errors.get('subscription') }}</p>

            <div class="payment-footer form__footer">
                <a @click.prevent="$emit('page', 'plans')" href="#" class="button button--small button--link">Cancel</a>
                <button type="submit" class="lc-submit button button--primary button--small" :disabled="isProcessing || form.busy">Pay</button>
            </div>
        </form>
    </div>
</template>
<script>
/* global EventBus */
import { mapGetters, mapState } from 'vuex'
import PaymentMethod from './PaymentMethod'
import Coupon from './Coupon'
import Form from '../../../helpers/Form'
import currentTenantAware from '../../../mixins/currentTenantAware'

export default {
    mixins: [currentTenantAware],

    data () {
        return {
            paymentIntent: null,
            isProcessing: false,
            form: new Form({
                interval: 'yearly',
                coupon: '',
                payment_method_id: ''
            })
        }
    },

    methods: {
        changeInterval (interval) {
            this.form.interval = interval
        },

        submit () {
            if (this.isProcessing) {
                return
            }

            this.isProcessing = true

            this.$refs.paymentMethod.setup((intent) => {
                this.form.payment_method_id = intent.payment_method

                this.$store.dispatch('tenant/upgradeAccount', this.form).then(() => {
                    this.$store.dispatch('tenant/fetchInvoices')
                    EventBus.$emit('newSnackbar', 'Account upgraded')
                    this.$emit('page', 'plans')
                })
            }).finally(() => {
                this.isProcessing = false
            })
        }
    },

    computed: {
        ...mapState('tenant', ['yearlyPrice', 'monthlyPrice', 'totalYearlyPrice', 'totalMonthlyPrice']),

        ...mapGetters({
            activeMembers: 'tenant/activeMembers'
        })
    },

    components: {
        PaymentMethod,
        Coupon
    }
}
</script>
